module.exports = __webpack_public_path__ + "img/crm.8e24fb08.png";